import { suggestedService } from "../services/suggestedService";
import {useState, useEffect} from "react";
import logger from '../utils/logger';

export const useSuggestedItems = (searchValue) => {

    const [suggested, setSuggested] = useState([]);
    const [error, setError] = useState('');
    let timeoutId = null;

    useEffect(() => {

        if (timeoutId) {
            clearTimeout(timeoutId);
          }

        timeoutId = setTimeout(async () => {

            try {
                const suggestedData = await suggestedService(searchValue);
                setSuggested(suggestedData);
            } catch (error) {
                logger.error('Error fetching search suggestions:', error)
                setError(error);
            }
        }, 700);

        return () => {
            clearTimeout(timeoutId);
          };

    }, [searchValue]);

    return {
        suggested,
        error
    }
}